import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Groups from "@/views/Groups";
import GroupEdit from "@/views/GroupEdit";
import GroupEditDetails from "@/views/GroupEditDetails";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/groups",
      name: "groups",
      component: Groups
    },
    {
      path: "/groups/:id",
      name: "groups-edit",
      component: GroupEdit
    },
    {
      path: "/groups/:id/Details",
      name: "groups-edit-details",
      component: GroupEditDetails
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
